import { Table } from 'antd';
import styled from 'styled-components';
import { type ITableRowErrorable } from '../ITableRow.ts';

/**
 * Stili per la tabella lato frontend compilazione.
 * Prende in input solo row di tipo `ITableRowErrorable`.
 */
export const $TableInputWidgetRowsTable = styled(Table<ITableRowErrorable>)`
  // Stili custom per gestione righe di errore aggiuntive
  &.ant-table-wrapper {
    .ant-table-tbody > tr {
      cursor: default;

      &.table-input-row > td {
        // Nascondiamo il bordo inferiore della riga "normale"
        // per "unirla" alla successiva con gli errori (.table-input-row-error)
        // che è sempre presente
        border-bottom-width: 0;
        .ant-form-item-explain {
          // Nascondiamo gli errori della riga "normale"
          display: none;
        }
      }

      &.table-input-row:hover + .table-input-row-error {
        > td {
          background-color: ${props => props.theme.controlItemBgHover};
        }
      }

      &.ant-table-row.table-input-row-error:hover {
        > td.ant-table-cell-row-hover {
          background-color: white;
        }
      }

      /* &.table-input-row-error:hover {
        > td.ant-table-cell-row-hover {
          background-color: 'white';
        }
      } */

      &.table-input-row-error {
        > td {
          padding-top: 0;
          padding-bottom: 0;
          vertical-align: top;

          &.rows-header {
            // Nascondiamo il contenuto della prima colonna (il nome della riga)
            > * {
              visibility: hidden;
              display: none;
            }
          }
          .ant-form-item-explain {
            text-align: left;
          }
        }
      }
    }
  }
  // Header
  // Impostazione colore sfondo dell'indagine
  .ant-table-thead > tr {
    > th,
    > td {
      color: #fff;
      background-color: ${props =>
        props.theme.engine.accentColor ?? props.theme.colorPrimary};
    }
  }
  .ant-table-title {
    color: #fff;
    background-color: ${props =>
      props.theme.engine.accentColor ?? props.theme.colorPrimary};
    font-weight: 500;
    border-bottom: 1px solid #fff;
  }

  // inserimento filo in testa alla tabella se non viene mostrata l'header
  .ant-table-content {
    border-top: 1px solid ${props => props.theme.colorSplit};
  }
  // correzione filo divisorio colonne
  .ant-table-thead > tr {
    > th,
    > td {
      &:not(:last-child):not(.ant-table-selection-column):not(
          .ant-table-row-expand-icon-cell
        ):not([colspan])::before {
        position: absolute;
        top: 0;
        bottom: 0;
        inset-inline-end: 0;
        width: 1px;
        height: 100%;
        background-color: #fff;
        transform: translateY(0);
        transition: background-color 0.2s;
        content: '';
      }
    }
    .ant-table-cell {
      &.front-table-thead-group {
        + .front-table-thead-item,
        + .front-table-thead-group {
          &::after {
            position: absolute;
            z-index: 1;
            top: 0;
            bottom: 0;
            left: -1px;
            width: 1px;
            height: 100%;
            background-color: #fff;
            transform: translateY(0);
            transition: background-color 0.2s;
            content: '';
          }
        }
      }
      /* &.front-table-thead-group-item.item-last-child {
        &::before {
          display: none;
        }
      } */
    }
  }
  /* Impostazione colori alternativi header tabella */
  &.table-input-light-header {
    .ant-table-thead > tr {
      > th,
      > td {
        color: ${props => props.theme.colorText};
        background-color: #fff;
      }
    }
    .ant-table-title {
      color: ${props => props.theme.colorText};
      background-color: #fff;
      border-bottom-color: ${props => props.theme.colorText};
    }
    // correzione filo divisorio colonne
    .ant-table-thead > tr {
      > th,
      > td {
        &:not(:last-child):not(.ant-table-selection-column):not(
            .ant-table-row-expand-icon-cell
          ):not([colspan])::before {
          background-color: ${props => props.theme.colorSplit};
        }
      }
      .ant-table-cell {
        &.front-table-thead-group {
          + .front-table-thead-item,
          + .front-table-thead-group {
            &::after {
              background-color: ${props => props.theme.colorSplit};
            }
          }
        }
      }
    }
  }

  // Riduciamo il padding verticale nelle celle dell'header
  .ant-table-thead > tr {
    > th,
    > td {
      &.ant-table-cell {
        &.front-table-thead-group,
        &.front-table-thead-item,
        &.front-table-thead-group-item {
          padding: 4px 8px;
        }
      }
    }
  }

  // Body
  // Fix spazio dopo checkbox e radio
  .ant-table-tbody > tr > td {
    .ant-checkbox-wrapper,
    .ant-radio-wrapper {
      margin-right: 0;
    }
    .remove-label-space,
    .hide-visual-label {
      .ant-radio-wrapper,
      .ant-checkbox-wrapper {
        margin-top: 0;
      }
    }
  }
  // fix rimuovi spazio sotto i campi di input
  .ant-table-tbody > tr > td {
    .ant-form-item {
      margin-bottom: 0;
      padding-top: 0;
    }
  }
  // end fix rimuovi spazio sotto i campi

  // fix per centrare le checkbox e i radio nelle celle della tabella
  // che vengono inseriti senza label
  .ant-table-tbody > tr > td {
    &.front-table-thead-item,
    &.front-table-thead-group-item {
      .ant-checkbox-wrapper span.ant-checkbox,
      .ant-radio-wrapper span.ant-radio {
        + span:empty {
          padding: 0;
        }
      }
      // per l'accessibilità è necessario che il label sia presente nell'html
      // quindi dobbiamo rimuovere il padding quando il label è nascosto
      // come se non fosse presente (span:empty)
      .hide-label {
        &.ant-checkbox-wrapper span.ant-checkbox,
        &.ant-radio-wrapper span.ant-radio {
          + span {
            padding: 0;
          }
        }
      }
    }
  }
  // end fix per centrare le checkbox e i radio
`;
